export default __webpack_public_path__ + "static/media/login-img-3.7a35bf18.jpeg";